/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../features/dashboard/dashboardPreferences/DashboardPreferencesAPI'
], function (DashboardPreferencesAPI) {
	class DashboardPreferences extends DashboardPreferencesAPI {

		constructor() {
			super();
			this.preferences = [];
		}
		/**
		 * @description get a attribute that was set in the preferences
		 * @param {string} name the name of the preference to get
		 * @return {(string|boolean|number|null|undefined)} the value of the preference; null means the property will be removed when saved
		 */
		getPreference(name) {
			return this.preferences[name];
		}

		getAPI() {
			return this;
		}

		/**
		 * @description set the preference
		 * @param {string} name the name of the preference to set
		 * @param {(string|boolean|number|null)} value the value of the preference to set; exception is thrown when it is not one of these types
		 */
		setPreference(name, value) {
			this.preferences[name] = value;
		}

		/**
		 * @description save the preferences
		 * @returns {Promise} the promise is rejected if the save did not complete successfully
		 */
		savePreferences() {
			throw new Error('need to be implemented.');
		}
	}

	DashboardPreferences.create = () => {
		return new DashboardPreferences();
	};

	return DashboardPreferences;
});
